import { TextractServiceException as __BaseException } from "./TextractServiceException";
export class AccessDeniedException extends __BaseException {
    name = "AccessDeniedException";
    $fault = "client";
    Message;
    Code;
    constructor(opts) {
        super({
            name: "AccessDeniedException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, AccessDeniedException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export const FeatureType = {
    FORMS: "FORMS",
    LAYOUT: "LAYOUT",
    QUERIES: "QUERIES",
    SIGNATURES: "SIGNATURES",
    TABLES: "TABLES",
};
export const AdapterVersionStatus = {
    ACTIVE: "ACTIVE",
    AT_RISK: "AT_RISK",
    CREATION_ERROR: "CREATION_ERROR",
    CREATION_IN_PROGRESS: "CREATION_IN_PROGRESS",
    DEPRECATED: "DEPRECATED",
};
export const ContentClassifier = {
    FREE_OF_ADULT_CONTENT: "FreeOfAdultContent",
    FREE_OF_PERSONALLY_IDENTIFIABLE_INFORMATION: "FreeOfPersonallyIdentifiableInformation",
};
export const BlockType = {
    CELL: "CELL",
    KEY_VALUE_SET: "KEY_VALUE_SET",
    LAYOUT_FIGURE: "LAYOUT_FIGURE",
    LAYOUT_FOOTER: "LAYOUT_FOOTER",
    LAYOUT_HEADER: "LAYOUT_HEADER",
    LAYOUT_KEY_VALUE: "LAYOUT_KEY_VALUE",
    LAYOUT_LIST: "LAYOUT_LIST",
    LAYOUT_PAGE_NUMBER: "LAYOUT_PAGE_NUMBER",
    LAYOUT_SECTION_HEADER: "LAYOUT_SECTION_HEADER",
    LAYOUT_TABLE: "LAYOUT_TABLE",
    LAYOUT_TEXT: "LAYOUT_TEXT",
    LAYOUT_TITLE: "LAYOUT_TITLE",
    LINE: "LINE",
    MERGED_CELL: "MERGED_CELL",
    PAGE: "PAGE",
    QUERY: "QUERY",
    QUERY_RESULT: "QUERY_RESULT",
    SELECTION_ELEMENT: "SELECTION_ELEMENT",
    SIGNATURE: "SIGNATURE",
    TABLE: "TABLE",
    TABLE_FOOTER: "TABLE_FOOTER",
    TABLE_TITLE: "TABLE_TITLE",
    TITLE: "TITLE",
    WORD: "WORD",
};
export const EntityType = {
    COLUMN_HEADER: "COLUMN_HEADER",
    KEY: "KEY",
    SEMI_STRUCTURED_TABLE: "SEMI_STRUCTURED_TABLE",
    STRUCTURED_TABLE: "STRUCTURED_TABLE",
    TABLE_FOOTER: "TABLE_FOOTER",
    TABLE_SECTION_TITLE: "TABLE_SECTION_TITLE",
    TABLE_SUMMARY: "TABLE_SUMMARY",
    TABLE_TITLE: "TABLE_TITLE",
    VALUE: "VALUE",
};
export const RelationshipType = {
    ANSWER: "ANSWER",
    CHILD: "CHILD",
    COMPLEX_FEATURES: "COMPLEX_FEATURES",
    MERGED_CELL: "MERGED_CELL",
    TABLE: "TABLE",
    TABLE_FOOTER: "TABLE_FOOTER",
    TABLE_TITLE: "TABLE_TITLE",
    TITLE: "TITLE",
    VALUE: "VALUE",
};
export const SelectionStatus = {
    NOT_SELECTED: "NOT_SELECTED",
    SELECTED: "SELECTED",
};
export const TextType = {
    HANDWRITING: "HANDWRITING",
    PRINTED: "PRINTED",
};
export class BadDocumentException extends __BaseException {
    name = "BadDocumentException";
    $fault = "client";
    Message;
    Code;
    constructor(opts) {
        super({
            name: "BadDocumentException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, BadDocumentException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export class DocumentTooLargeException extends __BaseException {
    name = "DocumentTooLargeException";
    $fault = "client";
    Message;
    Code;
    constructor(opts) {
        super({
            name: "DocumentTooLargeException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, DocumentTooLargeException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export class HumanLoopQuotaExceededException extends __BaseException {
    name = "HumanLoopQuotaExceededException";
    $fault = "client";
    ResourceType;
    QuotaCode;
    ServiceCode;
    Message;
    Code;
    constructor(opts) {
        super({
            name: "HumanLoopQuotaExceededException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, HumanLoopQuotaExceededException.prototype);
        this.ResourceType = opts.ResourceType;
        this.QuotaCode = opts.QuotaCode;
        this.ServiceCode = opts.ServiceCode;
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export class InternalServerError extends __BaseException {
    name = "InternalServerError";
    $fault = "server";
    Message;
    Code;
    constructor(opts) {
        super({
            name: "InternalServerError",
            $fault: "server",
            ...opts,
        });
        Object.setPrototypeOf(this, InternalServerError.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export class InvalidParameterException extends __BaseException {
    name = "InvalidParameterException";
    $fault = "client";
    Message;
    Code;
    constructor(opts) {
        super({
            name: "InvalidParameterException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, InvalidParameterException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export class InvalidS3ObjectException extends __BaseException {
    name = "InvalidS3ObjectException";
    $fault = "client";
    Message;
    Code;
    constructor(opts) {
        super({
            name: "InvalidS3ObjectException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, InvalidS3ObjectException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export class ProvisionedThroughputExceededException extends __BaseException {
    name = "ProvisionedThroughputExceededException";
    $fault = "client";
    Message;
    Code;
    constructor(opts) {
        super({
            name: "ProvisionedThroughputExceededException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ProvisionedThroughputExceededException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export class ThrottlingException extends __BaseException {
    name = "ThrottlingException";
    $fault = "server";
    Message;
    Code;
    constructor(opts) {
        super({
            name: "ThrottlingException",
            $fault: "server",
            ...opts,
        });
        Object.setPrototypeOf(this, ThrottlingException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export class UnsupportedDocumentException extends __BaseException {
    name = "UnsupportedDocumentException";
    $fault = "client";
    Message;
    Code;
    constructor(opts) {
        super({
            name: "UnsupportedDocumentException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, UnsupportedDocumentException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export const ValueType = {
    DATE: "DATE",
};
export const AutoUpdate = {
    DISABLED: "DISABLED",
    ENABLED: "ENABLED",
};
export class ConflictException extends __BaseException {
    name = "ConflictException";
    $fault = "client";
    Message;
    Code;
    constructor(opts) {
        super({
            name: "ConflictException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ConflictException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export class IdempotentParameterMismatchException extends __BaseException {
    name = "IdempotentParameterMismatchException";
    $fault = "client";
    Message;
    Code;
    constructor(opts) {
        super({
            name: "IdempotentParameterMismatchException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, IdempotentParameterMismatchException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export class LimitExceededException extends __BaseException {
    name = "LimitExceededException";
    $fault = "client";
    Message;
    Code;
    constructor(opts) {
        super({
            name: "LimitExceededException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, LimitExceededException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export class ServiceQuotaExceededException extends __BaseException {
    name = "ServiceQuotaExceededException";
    $fault = "client";
    Message;
    Code;
    constructor(opts) {
        super({
            name: "ServiceQuotaExceededException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ServiceQuotaExceededException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export class ValidationException extends __BaseException {
    name = "ValidationException";
    $fault = "client";
    Message;
    Code;
    constructor(opts) {
        super({
            name: "ValidationException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ValidationException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export class InvalidKMSKeyException extends __BaseException {
    name = "InvalidKMSKeyException";
    $fault = "client";
    Message;
    Code;
    constructor(opts) {
        super({
            name: "InvalidKMSKeyException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, InvalidKMSKeyException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export class ResourceNotFoundException extends __BaseException {
    name = "ResourceNotFoundException";
    $fault = "client";
    Message;
    Code;
    constructor(opts) {
        super({
            name: "ResourceNotFoundException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ResourceNotFoundException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
export const JobStatus = {
    FAILED: "FAILED",
    IN_PROGRESS: "IN_PROGRESS",
    PARTIAL_SUCCESS: "PARTIAL_SUCCESS",
    SUCCEEDED: "SUCCEEDED",
};
export class InvalidJobIdException extends __BaseException {
    name = "InvalidJobIdException";
    $fault = "client";
    Message;
    Code;
    constructor(opts) {
        super({
            name: "InvalidJobIdException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, InvalidJobIdException.prototype);
        this.Message = opts.Message;
        this.Code = opts.Code;
    }
}
